/* S18: PLP 絞り込みドロワーの開閉（凍結 collection_c_mobile_clean.html L1415 の挙動を移植）。
 *
 * モックからの継承: FAB / 絞り込みバーで開く・× / overlay click で閉じる・body.mfilter-open
 * クラスで CSS のスライドアップ（下開きドロワー）を駆動。
 *
 * モックとの乖離（S18 ADR・tol-ugc-modal.js 前例へ格上げ）:
 * - モックは id 直参照（mFilterOpen/Close/Overlay/Fab）→ data-* 属性 + 同一 .shopify-section 内
 *   スコープ解決（エディタのセクション再配置に強い）。
 * - モック非実装の a11y を補強: Escape で閉じる・trapFocus/removeTrapFocus（global.js 素関数・
 *   theme.liquid 先行ロード）でパネル内フォーカストラップ + 閉時に opener へ復帰。
 * - body.mfilter-open は CSS が依存するため維持（PLP は 1 ページ 1 グリッド前提でグローバル class 許容）。
 * - shopify:section:unload で開いたまま破棄されてもロック / リスナーを正規解除（S16 G2 MUST と同型）。
 *
 * マークアップ契約（解決は同一 .shopify-section 内）:
 *   <div data-tol-collection-grid>
 *     <div data-tol-filter-overlay></div>
 *     <aside data-tol-filter-panel> … <button data-tol-filter-close>× …
 *     <button data-tol-filter-open> …（FAB / SP バー・複数可）
 *
 * custom element は作らない（tol-ugc-modal.js / tol-tabs.js の IIFE + init ガード +
 * AbortController teardown を踏襲）。Dawn 本体無改修・tol- 隔離。
 *
 * --- R21（globo = smart-product-filter 結線面の追加配線）---
 * 結線面（.tol-collection-grid--globo）では、パネルの中身を globo が描く。加えて次を担う:
 * 1. ソート送信前に URL の globo パラメータ（gf_ / gff_）を hidden で再付与する。
 *    Liquid では不可能（request オブジェクトにクエリ文字列を取れるプロパティが無い＝公式は
 *    design_mode / host / locale / origin / page_type / path / visual_preview_mode のみで
 *    path はクエリを含まない）。かつ form.submit() は submit イベントを発火しないので
 *    submit ハンドラ方式は空振りする → change ハンドラ内で注入してから submit する。
 * 2. data-tol-globo-ready の管理（fail-closed）。「globo が実際に項目を入れた」ときだけ立て、
 *    FAB / SP バー / overlay / パネル中身の可視をこの属性で CSS ゲートする。
 *    ＝script 未到達・グリッド未発見・apiFilter 5xx/タイムアウト・filters 空・空ツリーの
 *    5 経路すべてで「空の器」「押しても何も出ない FAB」を出さない。
 * 3. globo の再描画で壊れるものの再確立（focus trap の張り直し・先頭群の初回展開）。
 * 4. 中身が無い状態で body.mfilter-open が残る事故の防止（overlay だけが残ると全面ロックになる）。
 * globo が #gf-tree を body へ移す挙動は、layout/theme.liquid の head 宣言（mobile_break_point = 1）で
 * 無効化してある＝ドロワーの器と閉じる手段はテーマが所有する。
 *
 * --- R21b（ハンズオン 10 件の是正・2026-09-04）---
 * 5. 待機表示（②）: globofilter.getFilterData をラップして取得開始を document イベントに変換し、
 *    data-tol-globo-loading を立てる。終了は globoFilterRenderCompleted＋watchdog。
 * 6. 「すべてクリア」（④）: window.clearAllFilter()（globo の公開グローバル）で AJAX 解除し、
 *    URL 遷移は 3 段 fallback に降格（single-flight・superseded 取り消し）。
 * 7. FAB（⑤）: SP バーが viewport 内にある間は data-tol-fab-hidden（IntersectionObserver）。
 * ページ番号クリック後のスクロール補正（⑦）は layout/theme.liquid の head で window.headerStickyHeight を
 * 定義して globo 側に任せる（globo が `#gf-grid.offset().top - headerStickyHeight` へ animate する実コード）。
 * ★globo の getFilterData / clearAllFilter / headerStickyHeight はコードリーディングで特定した非公式契約
 *   （公式ドキュメント無し）。いずれも無い / 変わったときは待機表示なし・URL 遷移・補正なしへ静かに退行する。
 */
(() => {
  if (window.__tolCollectionFiltersLoaded) return;
  window.__tolCollectionFiltersLoaded = true;

  const OPEN_CLASS = 'mfilter-open';
  /* globo の絞り込み状態を表す URL パラメータの接頭辞（実測: filter.prefix = 'gf_' /
     year_make_model.prefix = 'gff_'）。 */
  const GLOBO_PARAM_RE = /^(?:gf_|gff_)/;

  /* 現在の URL にある globo パラメータを form の hidden として貼り直す。
     - URLSearchParams は同名キーの繰り返しも順に列挙する（配列パラメータをそのまま保てる）。
     - 値はデコード済みで受け取り、送信時にブラウザが再エンコードする（+ / %20 の往復も保たれる）。
     - 呼び出しごとに前回ぶんを撤去して重複を作らない。
     globo が無効な面では gf_ パラメータが存在しないので no-op（placeholder 経路へ非波及）。 */
  const syncGloboParams = (form) => {
    form.querySelectorAll('input[data-tol-globo-param]').forEach((el) => el.remove());
    let params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (_) {
      return;
    }
    params.forEach((value, key) => {
      if (!GLOBO_PARAM_RE.test(key)) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      input.setAttribute('data-tol-globo-param', '');
      form.appendChild(input);
    });
  };

  const init = (root) => {
    root.querySelectorAll('[data-tol-collection-grid]').forEach((grid) => {
      if (grid.dataset.tolFilterInit) return;
      grid.dataset.tolFilterInit = 'true';

      const abort = new AbortController();
      const signal = abort.signal;

      /* ソート select の自動 submit（GET フォームは change で自動送信されない・Dawn facets と同型）。
         ソートはフィルター placeholder の有無に依存せず常に有効なため、開閉ロジックより前に設置。

         ★R21c（ハンズオン B-1・ユーザー裁定 2026-09-04）: globo 結線面では並び替えでページを
         リロードせず AJAX で差し替える。globo は公開グローバル `window.changeSortBy(value)` を持ち、
         Shopify の sort_by キー（best-selling / price-ascending …）をそのまま受けて
         `getFilterData` を通す（DEV 実測: 絞り込み `?gf_461229=1` を保ったまま
         `&sort_by=price-descending` へ pushState・先頭が ¥11,000 へ・リロードなし）。
         入口は下の globo 分岐が `grid._tolGloboSort` として置く（fetchSeq を見て「同期に取得が
         始まったか」を返す）。**始まらなかった／globo が居ない／非結線面は従来どおりフォーム送信**
         ＝並び替えが効かなくなる側には倒さない（決定 3「すべてクリア」と同じ fail-safe）。 */
      grid.querySelectorAll('[data-tol-sort]').forEach((sel) => {
        /* ★R21c: サーバー描画時の値を控える（下の popstate 同期で「sort_by が無い履歴」に戻すため）。 */
        if (!sel.dataset.tolSortInitial) sel.dataset.tolSortInitial = sel.value;
        sel.addEventListener(
          'change',
          () => {
            const form = sel.closest('form');
            const sortViaGlobo = grid._tolGloboSort;
            if (typeof sortViaGlobo === 'function' && sortViaGlobo(sel.value, form)) return;
            if (!form) return;
            /* R21: globo で絞り込んだ状態でソートしても絞り込みが落ちないように再付与する。 */
            syncGloboParams(form);
            form.submit();
          },
          { signal }
        );
      });

      const panel = grid.querySelector('[data-tol-filter-panel]');
      const overlay = grid.querySelector('[data-tol-filter-overlay]');
      const closeBtn = grid.querySelector('[data-tol-filter-close]');
      const openers = grid.querySelectorAll('[data-tol-filter-open]');
      /* placeholder OFF（フィルター非表示）の場合 panel が無い＝開閉ロジックはスキップ（ソートは上で設置済み）。
         この場合も abort/teardown は登録する（unload でソートリスナーを解除するため）。 */
      let opener = null;

      const isOpen = () => document.body.classList.contains(OPEN_CLASS);

      const open = (trigger) => {
        /* panel 不在（エディタで snippet だけ削除等）の防御ガード（G2 Copilot C-2） */
        if (!panel) return;
        opener = trigger || null;
        document.body.classList.add(OPEN_CLASS);
        if (typeof trapFocus === 'function') {
          trapFocus(panel, closeBtn || panel);
        } else if (closeBtn) {
          closeBtn.focus();
        }
      };

      const close = () => {
        if (!isOpen()) return;
        document.body.classList.remove(OPEN_CLASS);
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(opener);
        } else if (opener) {
          opener.focus();
        }
        opener = null;
      };

      grid._tolFilters = { abort, close };

      /* ---- R21: globo 結線面の配線 ---- */
      if (grid.classList.contains('tol-collection-grid--globo')) {
        /* globo は #gf-tree が既にあればそれを使うが、初期化の順序や幅判定の状況次第で
           **自前の #gf-tree を作ってしまう**ことがある（DEV 実機で 1 度再現: テーマの器から出て
           main 直下と body 直下に計 2 つ存在し、id 重複＋グリッド幅の縮小＋body 直下の
           in-flow 要素増加〔CLAUDE.md §3.4 の grid item 事故と同型〕が同時に起きた）。
           上の inline script（mobile_break_point = 1）が第一の予防だが、それに依存しきらず
           「#gf-tree はちょうど 1 つ・テーマのパネル配下」という不変条件を毎回修復する。 */
        /* R21b: globo の getFilterData（AJAX 取得）呼び出し通番。②の待機表示の起点と、
           ④の「clear が別操作に superseded されたか」の判定に使う（下の startLoading で加算）。 */
        let fetchSeq = 0;
        /* ★R21c: AJAX で始めた並び替えの保留（`{ seq, form, value }`）。成功＝URL の `sort_by` が
           要求値になること。失敗・無応答のまま watchdog / 追跡窓を使い切ったらフォーム送信へ落とす。 */
        let sortPending = null;

        /* ★R21c（ハンズオン B-1）: 並び替えの AJAX 入口。上のソート select の change ハンドラが
           これを呼び、**同期に globo の取得が始まったか（fetchSeq が進んだか）**を返す。
           false のときハンドラは従来どおりフォーム送信へ落ちる（globo 側の内部が変わって
           `changeSortBy` が取得を起こさなくなっても、並び替え自体は必ず効く）。
           ここを通ると `getFilterData` のラップが走るので②の待機表示もそのまま出る。 */
        grid._tolGloboSort = (value, form) => {
          if (typeof window.changeSortBy !== 'function') return false;
          const before = fetchSeq;
          try {
            window.changeSortBy(value);
          } catch (_) {
            return false;
          }
          if (fetchSeq === before) return false;
          /* ★取得は始まった。ただし globo は HTTP エラー・無応答のとき完了イベントを出さない
             （②の watchdog と同じ前提）ので、**始まっただけでは並び替えが効いた証明にならない**。
             成否が付くまで保留し、下の watchdog / URL 追跡窓が「効かなかった」と判定したら
             フォーム送信（サーバー描画）へ落とす。決定 3 の clear と同じ fallback の形。
             form が無い面（select が form の外）は落とし先が無いので保留しない
             ＝AJAX だけ試す（従来もその面では何も起きなかったので後退はしない）。 */
          sortPending = form ? { seq: fetchSeq, form: form, value: value } : null;
          return true;
        };
        signal.addEventListener(
          'abort',
          () => {
            grid._tolGloboSort = null;
            sortPending = null;
          },
          { once: true }
        );

        const blocksIn = (el) => el.querySelectorAll('.gf-option-block').length;
        const adoptTree = () => {
          if (!panel) return;
          const trees = Array.prototype.slice.call(document.querySelectorAll('[id="gf-tree"]'));
          if (trees.length < 2) {
            /* 1 つだけなら（無ければ何も）撤去しない。位置だけ器の中へ揃える。 */
            if (trees.length === 1 && trees[0].parentElement !== panel) panel.appendChild(trees[0]);
            return;
          }
          /* ★中身を持つものが 1 つも無いときは何も消さない（critical BLOCKER-2）。
             globo は「自分が作ったノードの参照を保持して後から中身を書き込む」型なので、
             まだ空の globo 側ノードを消すと以降の描画がデタッチされたノードへ流れ、
             .gf-option-block が永遠に 0＝**絞り込みが恒久的に出ない**状態で固定される
             （FAB も出ず Console も無言なので気づけない）。次の描画完了イベントで再判定する。 */
          const populated = trees.filter((t) => blocksIn(t) > 0);
          if (!populated.length) return;
          const keep = populated[0];
          if (keep.parentElement !== panel) panel.appendChild(keep);
          trees.forEach((t) => {
            if (t !== keep && blocksIn(t) === 0) t.remove();
          });
        };

        const treeOf = () => document.getElementById('gf-tree');

        /* 「globo が実際に絞り込み項目を入れた」の判定。
           globo 自身も中身が無いときは #gf-tree に spf-hidden（display:none !important）を付ける。 */
        /* URL に globo の絞り込みパラメータが載っているか（＝いま絞り込み中か）。 */
        const hasActiveGloboParams = () => {
          try {
            let found = false;
            new URLSearchParams(window.location.search).forEach((_v, k) => {
              if (GLOBO_PARAM_RE.test(k)) found = true;
            });
            return found;
          } catch (_) {
            return false;
          }
        };

        const treeReady = () => {
          const tree = treeOf();
          if (!tree) return false;
          /* ★絞り込み中は「出口」を閉じない（critical HIGH-1）。
             0 件ヒット時 globo は #gf-tree に spf-hidden を付ける（実測）。それを「未準備」と
             扱うと FAB・SP バー・パネル（＝「すべてクリア」を含む）まで消えて、
             **絞り込みを解除する手段が画面から無くなる**（戻るか手 URL 編集しか残らない）。
             gf_ パラメータが載っている間は器と解除導線を出したままにする。 */
          if (hasActiveGloboParams()) return true;
          if (tree.classList.contains('spf-hidden')) return false;
          return tree.querySelectorAll('.gf-option-block').length > 0;
        };

        /* globo が自前のページャ（#gf_pagination_wrap）を出したかどうか。
           サーバー描画のページネーションを隠す判定に使う。
           ★html.spf-has-filter では判定できない——同クラスは「globo がグリッドを掴んだ」時点で付き、
           apiFilter が 5xx / タイムアウトで**描画に失敗しても付いたまま**なので、それを条件にすると
           「globo のページャも無い・テーマのページャも消えている」＝980 商品の一覧でページ送りが
           完全に消える状態になる（DEV の障害注入で実発現）。 */
        /* 「globo が実際にグリッドを描いたか」。data-tol-handle は globo 用テンプレート
           （snippets/tol-globo-product-template.liquid）だけが出す属性なので、サーバー描画のカードと
           確実に区別できる。
           ★#gf_pagination_wrap の**存在**では判定できない（実測）: globo は描画に失敗しても
           空のページャ器を作るため、存在で判定すると「globo のページャも空・テーマのページャも
           非表示」で 980 商品の面がページ送り不能になる（DEV の障害注入 2 パターンで実発現）。
           ★逆に中身（リンク数）で判定すると、globo が 1 ページに絞り込んだ正常系で
           サーバー描画の stale なページャが出てしまう。だから「globo が描いたか」で判定する。 */
        const globoRenderedGrid = () => {
          const g = document.getElementById('gf-products');
          return !!g && !!g.querySelector('[data-tol-handle]');
        };
        const syncGloboPager = () => {
          if (globoRenderedGrid()) {
            grid.setAttribute('data-tol-globo-pager', '');
          } else {
            grid.removeAttribute('data-tol-globo-pager');
          }
        };
        /* globo がページャを挿すのは requestAnimationFrame の中（実コード）で、描画完了イベントとの
           前後関係は保証されない。1 フレームだけ見て見逃すとテーマと globo のページャが二重に出る
           （980 商品の面）ので短時間だけ数回追う（critical MEDIUM-3）。 */
        let pagerTimer = null;
        /* abort リスナーは 1 回だけ登録する（syncGloboPagerSoon は再描画ごとに呼ばれるので、
           中で登録すると signal にリスナーが積み上がる）。 */
        signal.addEventListener('abort', () => { if (pagerTimer) clearTimeout(pagerTimer); }, { once: true });
        const syncGloboPagerSoon = () => {
          syncGloboPager();
          if (pagerTimer) clearTimeout(pagerTimer);
          let tries = 0;
          const tick = () => {
            tries += 1;
            syncGloboPager();
            if (tries < 6 && !globoRenderedGrid()) {
              pagerTimer = setTimeout(tick, 120);
            }
          };
          requestAnimationFrame(tick);
        };

        /* ★`allowTeardown` で「ready を剥がして閉じる」破壊的分岐を分ける（critical HIGH-2）。
           この分岐に落ちると FAB / SP バー / overlay / パネル中身が CSS ゲートで一斉に消え、
           **復帰経路が無い**（URL は再変化しないので追跡 tick は評価を呼び直さず、
           globoFilterRenderCompleted も発火済み、ツリーは隠れているのでクリックもできない）。
           一方 treeReady() は URL に gf_ が無いとき `.gf-option-block` の件数に落ちるので、
           「最後のチェックを外して gf_ が消える適用」では **params 不在** と
           **globo がツリーを差し替えている最中（件数 0）** が同時に成立しうる。
           そこへ 250ms タイマーが着地すると、正常な操作の途中で絞り込み UI が落ちて固定される。
           → 破壊分岐は「globo が描き終えたと宣言した瞬間」（globoFilterRenderCompleted）と
           init だけに残し、タイマー / popstate からは立てる方向だけの非破壊 reconcile を呼ぶ。 */
        const reconcileGlobo = (allowTeardown) => {
          adoptTree();
          syncGloboPagerSoon();
          applyPriceOverrides();
          syncClearButton();
          if (!treeReady()) {
            if (allowTeardown) {
              grid.removeAttribute('data-tol-globo-ready');
              /* 中身が無いのに開いたままだと overlay だけが残って全面がクリック不能になる。 */
              close();
            }
            return;
          }
          grid.setAttribute('data-tol-globo-ready', '');
          /* 凍結ワイヤーは先頭群が展開状態。globo は全群 is-collapsed で描くので初回だけ外す
             （CSS では開けない。利用者が閉じたあとに再展開しないよう 1 度だけ）。
             ★ここで開くのは先頭群だけ＝**2 群目以降の中身（globo の .gf-block-content）は
             既定で display:none**。だからツリー内の寸法や computed style を測るときは、
             先に globo のトグルで展開しないと rect が必ず 0×0 になる。それを「見えない」と
             読むと存在しない退行を報告する（実例 = 2026-09-03 にレビュー数群の★アイコンを
             0×0 と誤検出。開けば 18×18px で表示されていた・critical MEDIUM-6）。 */
          if (!grid.dataset.tolGloboFirstOpen) {
            grid.dataset.tolGloboFirstOpen = '1';
            const first = treeOf().querySelector('.gf-option-block');
            if (first) first.classList.remove('is-collapsed');
          }
          /* 開いたままフィルタを適用すると globo が #gf-tree の中身を差し替えるため、
             trapFocus が保持している focusable ノードが DOM から消える → 張り直す。
             ★focus は動かさない（critical MEDIUM-5）: 再描画ごとに「×」へ飛ばすと
             キーボード / スクリーンリーダーの位置がチェックのたびに先頭へ戻る。
             パネル内にフォーカスが残っていればそこを維持する。 */
          if (isOpen() && panel && typeof trapFocus === 'function') {
            const active = document.activeElement;
            const keepFocus = active && panel.contains(active) ? active : null;
            if (typeof removeTrapFocus === 'function') removeTrapFocus();
            trapFocus(panel, keepFocus || closeBtn || panel);
          }
        };
        /* イベント / init 経路（破壊分岐あり＝従来どおり）。 */
        const syncGloboReady = () => reconcileGlobo(true);
        /* タイマー / popstate 経路（ready を剥がさない・閉じない）。 */
        const reconcileGloboSafe = () => reconcileGlobo(false);

        /* 「すべてクリア」（凍結ワイヤーのヘッダー右端）。globo はこの設定で clear-all を出さない
           （実測: .gf-clear-all 不在）。絞り込みは URL の gf_ / gff_ 駆動でフルページ遷移するので、
           それらを外した URL へ遷移するだけで解除と等価＝globo の内部 API に依存しない。
           絞り込みが 1 つも無いときは出さない（押しても何も起きないボタンを出さない）。 */
        const clearBtn = grid.querySelector('[data-tol-filter-clear]');
        const cleanUrl = () => {
          let params;
          try {
            params = new URLSearchParams(window.location.search);
          } catch (_) {
            return null;
          }
          const keys = [];
          params.forEach((_v, k) => {
            if (GLOBO_PARAM_RE.test(k)) keys.push(k);
          });
          if (!keys.length) return null;
          keys.forEach((k) => params.delete(k));
          /* ページ番号も落とす（1 ページ目へ戻す）。 */
          params.delete('page');
          const q = params.toString();
          return window.location.pathname + (q ? '?' + q : '');
        };
        /* ★表示判定は init 時 1 回では足りない（critical HIGH-2）。globo が pushState だけで
           絞り込む経路だと、読み込み時に gf_ が無いまま絞り込みが適用され「すべてクリア」が
           永久に出ない。描画完了ごとに再評価する（当ストアの実測では適用はフルページ遷移だったが、
           アプリ側の実装依存なのでどちらでも成り立つ形にしておく）。 */
        const syncClearButton = () => {
          const url = cleanUrl();
          /* R21b ④: gf_/gff_ が URL から消えた＝clear 成功（fallback を解除）。 */
          if (clearPending && !url) clearPending = false;
          if (!clearBtn) return;
          clearBtn.hidden = !url;
          clearBtn.dataset.tolClearUrl = url || '';
        };
        /* ---- R21b ④: 「すべてクリア」はリロードせずに解除する ----
           旧実装（location.assign のフルロード）は、サーバー描画の aside が data-tol-globo-ready まで
           visibility:hidden なので「サイドナビが一度消えて再描画される」ちらつきになっていた（ハンズオン④）。
           globo は公開グローバル window.clearAllFilter() を持ち、自前 refine の「すべてクリア」も同関数を
           呼ぶ（queryParams.filter 削除 → チェック解除 → page リセット → getFilterData("all") の AJAX 再描画）。
           これを第一経路にし、URL 遷移は fallback に降格する（DECISIONS 2026-09-03（3）決定 8 の部分 supersede）。
           - single-flight: 進行中（clearPending）は再入しない（連打で clearAllFilter が複数回走らない）。
           - fallback (a) 関数が無い／同期例外 → 即 URL 遷移
                      (b) 呼んだのに getFilterData が同期で走らなかった（内部が変わって no-op）→ 即 URL 遷移
                      (c) 走ったが watchdog 満了時にまだ gf_ が URL に残る → URL 遷移
           - 進行中に利用者が別の絞り込みを開始したら（別の getFilterData を観測）clear は superseded＝
             fallback を取り消す（放置すると (c) で cleanUrl へ遷移し、新しい選択を捨てる）。
           - 成功判定は「URL から gf_/gff_ が消えた」こと（既存の URL 追跡窓 → syncClearButton が観測）。
             完了イベントは成功の証明にならない（URL 更新前に来る・別処理の完了でも来る）。 */
        let clearPending = false;
        let clearSeq = 0;
        const clearViaUrl = () => {
          const url = (clearBtn && clearBtn.dataset.tolClearUrl) || cleanUrl();
          if (url) window.location.assign(url);
        };
        /* ★R21c: 保留中の並び替えが「効いた」判定 = URL の sort_by が要求値になったこと。
           完了イベントは成功の証明にしない（決定 3 と同じ理由＝URL 更新より前に来る）。
           ★ただし globo は **app 側の既定ソートに戻したときだけ sort_by を URL から外す**
           （DEV 実測 2026-09-04: 5 値のうち best-selling だけ `?sort_by=` が消えて `search` が空になる。
           既定値は `GloboEmbedFilterConfig.collection.sort` = "best-selling"＝決定 7 で実測済みの値）。
           これを見落とすと「AJAX は成功しているのに追跡窓の終端でフォーム送信＝5 秒後にフルリロード」
           という B-1 の依頼と逆向きの誤爆になる（critical HIGH-2）。
           config が読めないときは厳しい判定のまま＝フォーム送信へ落ちる（サーバー描画は必ず正しい）。 */
        const globoDefaultSort = () => {
          const cfg = window.GloboEmbedFilterConfig && window.GloboEmbedFilterConfig.collection;
          return cfg && typeof cfg.sort === 'string' && cfg.sort ? cfg.sort : null;
        };
        const sortSettled = () => {
          if (!sortPending) return false;
          let cur;
          try {
            cur = new URLSearchParams(window.location.search).get('sort_by');
          } catch (_) {
            return false;
          }
          if (cur === sortPending.value) return true;
          if (cur === null && globoDefaultSort() === sortPending.value) return true;
          return false;
        };
        /* ★R21c: 並び替えの fallback。AJAX が無応答・失敗のまま終わったらサーバー描画へ落とす
           （globo の絞り込みは hidden で貼り直す＝従来のフォーム送信と同じ結果になる）。 */
        const sortViaForm = () => {
          const pending = sortPending;
          sortPending = null;
          if (!pending || !pending.form) return;
          syncGloboParams(pending.form);
          pending.form.submit();
        };
        if (clearBtn) {
          clearBtn.addEventListener(
            'click',
            () => {
              if (clearPending) return;
              if (typeof window.clearAllFilter !== 'function') {
                clearViaUrl();
                return;
              }
              clearPending = true;
              clearSeq = 0;
              const before = fetchSeq;
              try {
                window.clearAllFilter();
              } catch (_) {
                clearPending = false;
                clearViaUrl();
                return;
              }
              /* getFilterData は clearAllFilter の中で同期に呼ばれる（実コード）。1 フレーム待って
                 開始フックが動いていなければ内部が変わったと見て URL 遷移へ。 */
              /* clear の通番（clearSeq）は startLoading 側が「clearPending 中の最初の fetch」で即確定する
                 （rAF まで待つと同一フレーム内の別取得を clear 本体と誤認し、その新しい選択を fallback が
                 消す・Codex MEDIUM）。ここは「取得が始まらなかった」判定だけを行う。 */
              requestAnimationFrame(() => {
                if (!clearPending) return;
                if (fetchSeq === before) {
                  clearPending = false;
                  clearViaUrl();
                }
              });
            },
            { signal }
          );
        }
        /* ★globo の適用は「フルページ遷移」ではなく pushState + AJAX で、**再描画完了イベントの
           あとに pushState する**（実測 2026-09-03・R21 の ADR 決定 5 が置いていた前提の誤り）:
             click        → search=?gf_461229=1（変化前）
             renderCompleted → search=?gf_461229=1（**まだ古い**）
             +250ms       → search=?gf_461229=1&gf_461229=0（更新済み）
           このため描画完了ハンドラで 1 回だけ評価しても URL が古く、「すべてクリア」が hidden で
           残った（PC / SP 両方・リロードすると出る）。→ 評価をイベント時点の 1 回に固定せず、
           イベントを起点に短時間 URL を追う（下の globoFilterRenderCompleted 購読から呼ぶ）。
           クリックを拾う迂回はしない（フッター「見る N 商品」など UI 経路が増えても追随するため）。
           ページャの二重表示対策（syncGloboPagerSoon）と同型の追跡で、状態の持ち方を増やさない。 */
        let clearTimer = null;
        let lastSearch = window.location.search;
        signal.addEventListener('abort', () => { if (clearTimer) clearTimeout(clearTimer); }, { once: true });
        /* ★URL が変わったときに再評価するのは「すべてクリア」だけでは足りない（Codex HIGH-2）。
           globo は 0 件ヒットで #gf-tree に spf-hidden を付ける。描画完了イベントが pushState より
           先に来ると、その時点の評価では gf_ が無いので data-tol-globo-ready が外れ、あとから URL が
           変わっても ready は戻らない＝ボタンだけ論理的に hidden を解かれてもパネルごと閉じたままで、
           0 件の画面から解除手段が消える（決定 4 が閉じたはずの経路の再発）。
           だから URL 変化時は ready / ページャ / 価格 / clear をまとめて評価する syncGloboReady() を呼ぶ。 */
        const reconcileOnUrlChange = () => {
          if (window.location.search === lastSearch) return false;
          lastSearch = window.location.search;
          reconcileGloboSafe();
          return true;
        };
        const syncClearButtonSoon = () => {
          syncClearButton();
          if (clearTimer) clearTimeout(clearTimer);
          let tries = 0;
          const tick = () => {
            tries += 1;
            /* URL 変化を捉えたら窓を作り直す（適用が連続する / 応答が遅い場合に取りこぼさない）。
               pushState は popstate を発火しないので、この追跡が唯一の検知経路になる。 */
            if (reconcileOnUrlChange()) tries = 0;
            else syncClearButton();
            /* ★R21c: 並び替えが URL に載ったら保留を解く（成功）。 */
            if (sortPending && sortSettled()) sortPending = null;
            if (tries < 20) {
              clearTimer = setTimeout(tick, 250);
            } else {
              clearTimer = null;
              /* R21b ④ fallback (c'): 描画完了後 5 秒追っても gf_ が URL から消えない（globo が URL を
                 更新しない挙動に変わった等）。watchdog は描画完了で止まっているので、ここで URL 遷移へ。 */
              if (clearPending && cleanUrl()) {
                clearPending = false;
                clearViaUrl();
              }
              /* ★R21c: 並び替えも同じ。描画は完了したのに 5 秒追って sort_by が載らない
                 ＝AJAX 経路では効いていない（watchdog は完了で止まっている）→ フォーム送信へ。 */
              if (sortPending && !sortSettled()) sortViaForm();
            }
          };
          clearTimer = setTimeout(tick, 250);
        };
        /* ★R21c（critical MEDIUM-3）: AJAX ソートは pushState なので「戻る」でも実ナビゲーションが
           起きない＝並び替え select がその時の値のまま残り、URL・実際の並びと食い違う（従来の
           フォーム送信では実ナビゲーションでサーバーが正しい selected を返していた）。popstate で
           URL から select を戻す。`sort_by` が無い履歴（＝globo の既定ソート・初期表示）は
           サーバー描画時の値へ戻す＝「戻る」で初期状態がそのまま再現される。 */
        const syncSortSelect = () => {
          let urlSort;
          try {
            urlSort = new URLSearchParams(window.location.search).get('sort_by');
          } catch (_) {
            return;
          }
          grid.querySelectorAll('[data-tol-sort]').forEach((sel) => {
            const known =
              urlSort && Array.prototype.some.call(sel.options, (o) => o.value === urlSort);
            const want = known ? urlSort : sel.dataset.tolSortInitial;
            if (want && sel.value !== want) sel.value = want;
          });
        };
        window.addEventListener(
          'popstate',
          () => {
            lastSearch = window.location.search;
            reconcileGloboSafe();
            syncSortSelect();
          },
          { signal }
        );
        syncClearButton();

        /* globo のフッター「見る N 商品」は SP で「適用して閉じる」として活かす。
           globo 自身のハンドラ（toggleCanvas）はテーマのドロワーを閉じないのでイベント委譲で補う。
           要素は globo が再描画ごとに作り直すので、パネルに 1 度だけ委譲を貼る。 */
        if (panel) {
          panel.addEventListener(
            'click',
            (e) => {
              const t = e.target && e.target.closest ? e.target.closest('.gf-filter-footer button') : null;
              if (t) close();
            },
            { signal }
          );
        }

        /* 価格上書き MF（price.store / store.price・LB 7-26(b)）の救済の **fallback**。
           ★2026-09-03 の追修正で位置づけが変わった: 当初の「globo のペイロードには price 系 MF が
           来ない（実測）」は母集団の誤りで、**商品ごとにその商品が持つ MF が来る**（apiFilter の
           レスポンスで確認）。主たる救済は globo 用テンプレートが `price.store` を直接読む方
           （snippets/tol-globo-product-template.liquid・LIVE 同方式）で、こちらは型未定義の
           `store.price` やインデックス未反映で値が来ない場合の保険として残す。
           サーバー側が出した handle → 表示価格のマップ（script[data-tol-price-map]）で貼り直す。
           XSS を作らないため innerHTML は使わず textContent と createElement だけで組む。 */
        let priceMap = null;
        const getPriceMap = () => {
          if (priceMap) return priceMap;
          priceMap = {};
          const node = document.querySelector('script[data-tol-price-map]');
          if (!node) return priceMap;
          try {
            priceMap = JSON.parse(node.textContent) || {};
          } catch (_) {
            priceMap = {};
          }
          return priceMap;
        };
        const taxSuffix = () => {
          /* サーバー描画のカードから（税込）の文字列を借りる（locale キーを JS に焼かない）。 */
          const el = document.querySelector('.tol-price-tax');
          return el ? el.textContent : '';
        };
        const applyPriceOverrides = () => {
          const map = getPriceMap();
          const handles = Object.keys(map);
          if (!handles.length) return;
          const suffix = taxSuffix();
          grid.querySelectorAll('#gf-products [data-tol-handle]').forEach((wrap) => {
            const amount = map[wrap.getAttribute('data-tol-handle')];
            if (!amount) return;
            const priceEl = wrap.querySelector('.tol-product-card__price');
            if (!priceEl || priceEl.dataset.tolPriceFixed === '1') return;
            /* ds04 #35: セール用の修飾子（flex）を外す。残すと金額と（税込）が別の flex 項目になって間が空く。
               この経路は元価格を出さない（DECISIONS 2026-10-06（6）決定 2）。 */
            priceEl.classList.remove('tol-product-card__price--sale');
            priceEl.textContent = amount;
            if (suffix) {
              const small = document.createElement('small');
              small.className = 'tol-price-tax';
              small.textContent = suffix;
              priceEl.appendChild(small);
            }
            priceEl.dataset.tolPriceFixed = '1';
          });
        };

        /* ★globo が結局読めなかったときは予約した 3/12 列を畳んで全幅へ戻す（critical / Codex 両系統一致）。
           fail-closed のために操作 UI を出さないだけだと、PC では**空の 25% 幅の柱が恒久的に残る**
           （スクリプト遮断・拡張機能・アプリ障害のとき）。一定時間たっても ready にならず、
           絞り込み中でもなければ結線前と同じ全幅レイアウトに戻す＝退行ではなく現状復帰。
           正常系は実測 2 秒未満で ready になるので誤発火しないよう余裕を取る（遅延の分だけ
           失敗時に一度レイアウトが動くが、失敗時だけなので許容する）。 */
        const FAILED_ATTR = 'data-tol-globo-failed';
        let failTimer = setTimeout(() => {
          if (!grid.hasAttribute('data-tol-globo-ready')) grid.setAttribute(FAILED_ATTR, '');
          /* ページャの帰属も再判定する（globo が空の器だけ作って終わっている場合に
             テーマのページャを戻すため）。 */
          syncGloboPager();
        }, 6000);
        signal.addEventListener('abort', () => clearTimeout(failTimer), { once: true });
        const clearFailed = () => {
          if (failTimer) { clearTimeout(failTimer); failTimer = null; }
          grid.removeAttribute(FAILED_ATTR);
        };

        /* ---- R21b ②: globo の AJAX 取得中の待機表示 ----
           globo は初回だけ html.spf-filter-loading → spf-status-loaded を切り替え、絞り込み・ページ送りの
           AJAX 中はクラスもイベントも出さない（実コード: spf-status-loading は load-more 専用）。
           開始 = globofilter.getFilterData のラップ（公開グローバル setPage / changeSortBy / clearAllFilter …
           もすべてここを通る唯一の取得口）。利用者操作の委譲は採らない——fetch を伴わない操作（チェック済みの
           再クリック・slider ハンドルに触れるだけ）で偽の待機表示が長く残る。
           終了 = globoFilterRenderCompleted。失敗（HTTP エラー・無応答）は globo がイベントを出さないので
           watchdog（globo 自身の fetch timeout `window.filterAjaxTimeOut || 15000` ＋ 1 秒）で必ず外す。
           single-flight は globo の性質に乗る（getFilterData は冒頭で前リクエストを abort するので連打しても
           完了イベントは最後の 1 回だけ）。表示は 150ms 遅らせ、出したら最短 250ms 保つ（最速応答 ≈ 266ms で
           一瞬点滅する経路を潰す）。ラップできない環境では待機表示を出さない（現状と同じ・fail-closed）。
           ★globo 内部実装への依存（受容残）: アプリ更新で名前が変われば待機表示だけが静かに消える。 */
        const LOADING_ATTR = 'data-tol-globo-loading';
        const LOADING_DELAY = 150;
        const LOADING_MIN = 250;
        let loadingShowTimer = null;
        let loadingHideTimer = null;
        let loadingWatchdog = null;
        let loadingShownAt = 0;
        const productsEl = () => document.getElementById('gf-products');
        const hideLoading = () => {
          if (loadingShowTimer) { clearTimeout(loadingShowTimer); loadingShowTimer = null; }
          if (loadingWatchdog) { clearTimeout(loadingWatchdog); loadingWatchdog = null; }
          const apply = () => {
            loadingHideTimer = null;
            grid.removeAttribute(LOADING_ATTR);
            const p = productsEl();
            if (p) p.removeAttribute('aria-busy');
          };
          if (!grid.hasAttribute(LOADING_ATTR)) { apply(); return; }
          const elapsed = Date.now() - loadingShownAt;
          if (elapsed >= LOADING_MIN) { apply(); return; }
          if (loadingHideTimer) clearTimeout(loadingHideTimer);
          loadingHideTimer = setTimeout(apply, LOADING_MIN - elapsed);
        };
        const onLoadingTimeout = () => {
          /* ④ fallback (c): clear を始めたのに watchdog 満了まで gf_ が URL に残っている。 */
          if (clearPending) {
            clearPending = false;
            if (cleanUrl()) clearViaUrl();
          }
          /* ★R21c: 並び替えも同じ。globo は失敗・無応答では完了イベントを出さないので、
             ここに来た＝AJAX が返らなかった。無音の no-op にせずフォーム送信へ落とす（Codex HIGH）。 */
          if (sortPending && !sortSettled()) sortViaForm();
          else sortPending = null;
        };
        const startLoading = () => {
          fetchSeq += 1;
          /* ④: clearPending 中の最初の取得 = clear 本体（通番を確定）。2 つ目以降 = 利用者が別の絞り込みを
             始めた（superseded）＝fallback を取り消す（放置すると cleanUrl へ遷移して新しい選択を捨てる）。 */
          if (clearPending) {
            if (!clearSeq) clearSeq = fetchSeq;
            else if (fetchSeq > clearSeq) clearPending = false;
          }
          /* ★R21c: 並び替えの保留も superseded で取り消す（利用者が次の操作を始めたのに、
             あとから古いソートのフォーム送信でその操作を捨てない＝決定 3 と同じ）。 */
          if (sortPending && fetchSeq > sortPending.seq) sortPending = null;
          if (loadingHideTimer) { clearTimeout(loadingHideTimer); loadingHideTimer = null; }
          if (!grid.hasAttribute(LOADING_ATTR) && !loadingShowTimer) {
            loadingShowTimer = setTimeout(() => {
              loadingShowTimer = null;
              grid.setAttribute(LOADING_ATTR, '');
              loadingShownAt = Date.now();
              const p = productsEl();
              if (p) p.setAttribute('aria-busy', 'true');
            }, LOADING_DELAY);
          }
          if (loadingWatchdog) clearTimeout(loadingWatchdog);
          const base = typeof window.filterAjaxTimeOut === 'number' ? window.filterAjaxTimeOut : 15000;
          loadingWatchdog = setTimeout(() => {
            loadingWatchdog = null;
            hideLoading();
            onLoadingTimeout();
          }, base + 1000);
        };
        signal.addEventListener(
          'abort',
          () => {
            if (loadingShowTimer) clearTimeout(loadingShowTimer);
            if (loadingHideTimer) clearTimeout(loadingHideTimer);
            if (loadingWatchdog) clearTimeout(loadingWatchdog);
            grid.removeAttribute(LOADING_ATTR);
          },
          { once: true }
        );
        /* ラップは 1 度だけ・呼び出しは document のカスタムイベントに変換して配る（セクション再初期化で
           init が複数回走っても、古い init の閉包を掴まない）。globo が defer より遅く初期化される場合は
           最初の描画完了イベントで再試行する（init の初回取得は待機表示の対象外＝サーバー描画が見えている）。 */
        const wrapGloboFetch = () => {
          const gf = window.globofilter;
          if (!gf || typeof gf.getFilterData !== 'function' || gf.__tolFetchHooked) return;
          const orig = gf.getFilterData;
          try {
            gf.getFilterData = function () {
              try {
                document.dispatchEvent(new CustomEvent('tol:globo:fetch'));
              } catch (_) { /* 待機表示は補助機能＝取得本体を止めない */ }
              return orig.apply(this, arguments);
            };
            gf.__tolFetchHooked = true;
          } catch (_) { /* 差し替え不可なら待機表示なし（現状維持） */ }
        };
        document.addEventListener('tol:globo:fetch', startLoading, { signal });
        wrapGloboFetch();

        /* globo の再描画完了は window に発火する（globo 自身も window で購読している）。 */
        window.addEventListener(
          'globoFilterRenderCompleted',
          () => {
            hideLoading();
            wrapGloboFetch();
            clearFailed();
            syncGloboReady();
            /* ★イベント時点の URL は古い（上記実測）＝ここから短時間追う。
               syncGloboReady() 内の syncClearButton() は即時評価のままにしておき、
               窓の起点をイベントだけに持たせる（相互再帰にしない）。 */
            syncClearButtonSoon();
          },
          { signal }
        );
        syncGloboReady();
      }

      openers.forEach((btn) => {
        btn.addEventListener('click', () => open(btn), { signal });
      });

      /* R21b ⑤（ユーザー裁定 2026-09-04・凍結ワイヤーからの変更）: 本文先頭の絞り込みバーが viewport 内に
         ある間は右下 FAB を出さない（同じ役割のボタンが初回ビューで 2 つ見える状態の解消）。
         CSS は `[data-tol-fab-hidden] .tol-collection-grid__fab`。IO 非対応・バー不在の面では属性を付けない
         ＝従来どおり常時表示（FAB が消えて絞り込みを開けなくなる側には倒さない）。 */
      const spBar = grid.querySelector('.tol-collection-grid__sp-bar');
      if (spBar && 'IntersectionObserver' in window) {
        /* ★sticky ヘッダーの裏に入ったバーも IO は「可視」と数える（root は viewport 全体・遮蔽は見ない）ので、
           その区間で FAB まで消えると絞り込みを開く導線がゼロになる（Codex MEDIUM）。ヘッダー高ぶんを
           負の rootMargin で除外し、幅でヘッダー高が変わるので resize で observer を作り直す。
           ヘッダー高は Dawn の StickyHeader が維持する --header-height（無ければ .section-header の実高）。 */
        const stickyHeaderHeight = () => {
          const h = document.querySelector('.section-header');
          if (!h) return 0;
          const cs = getComputedStyle(h);
          if (cs.position !== 'fixed' && (cs.position !== 'sticky' || cs.top === 'auto')) return 0;
          const v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
          return v > 0 ? v : h.getBoundingClientRect().height;
        };
        let io = null;
        const observeBar = () => {
          if (io) io.disconnect();
          io = new IntersectionObserver(
            (entries) => {
              entries.forEach((en) => {
                if (en.isIntersecting) grid.setAttribute('data-tol-fab-hidden', '');
                else grid.removeAttribute('data-tol-fab-hidden');
              });
            },
            { threshold: 0, rootMargin: `-${Math.round(stickyHeaderHeight())}px 0px 0px 0px` }
          );
          io.observe(spBar);
        };
        observeBar();
        let ioResizeTimer = null;
        window.addEventListener(
          'resize',
          () => {
            if (ioResizeTimer) clearTimeout(ioResizeTimer);
            ioResizeTimer = setTimeout(observeBar, 200);
          },
          { signal }
        );
        signal.addEventListener(
          'abort',
          () => {
            if (ioResizeTimer) clearTimeout(ioResizeTimer);
            if (io) io.disconnect();
            grid.removeAttribute('data-tol-fab-hidden');
          },
          { once: true }
        );
      }
      if (closeBtn) closeBtn.addEventListener('click', close, { signal });
      if (overlay) overlay.addEventListener('click', close, { signal });
      document.addEventListener(
        'keydown',
        (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE' && isOpen()) close();
        },
        { signal }
      );
    });
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-tol-collection-grid]').forEach((grid) => {
      if (!grid._tolFilters) return;
      /* 開いたまま unload されるとスクロールロック相当の body class と trapFocus リスナーが残る
         → close() で正規解除（閉じていれば no-op） */
      grid._tolFilters.close();
      grid._tolFilters.abort.abort();
    });
  });
})();
